<template>
  <div class="com-map">
    <div class="map-item" v-for="(item, index) in mapList" :key="index">
      <div class="map-name" v-if="item.map_name">
        <span>{{ item.map_name }}</span>
      </div>
      <div class="img" :style="{ opacity: item.action == 'BAN' ? '.5' : '1' }">
        <img v-hb-img.src="item.img" alt="" />
        <div class="map-name-mask" v-if="item.map_name"></div>
      </div>
      <div class="state" :class="item.action">
        <div class="team" v-if="item.action != 'LEFT'">
          <img v-hb-img.src="item.team_logo" alt="" />
        </div>
        <div class="state-text">
          <span>{{ item.action }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    matchData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mapList() {
      return this.dataInfo?.map?.map_list || [];
    },
  },
};
</script>

<style lang="less">
.com-map {
  padding: 10px;
  display: flex;
  background: rgba(250, 251, 252, 1);
  .map-item {
    border-radius: 3px;
    overflow: hidden;
    width: 0;
    flex: 1;
    position: relative;
    &:not(:last-child) {
      margin-right: 2px;
    }
    .map-name {
      position: absolute;
      left: 0;
      right: 0;
      top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 12px;
      width: 100%;
      z-index: 1;
      span {
        font-weight: 400;
        font-size: 12px;
        transform: scale(0.667);
        text-align: center;
        color: #ffffff;
        line-height: 12px;
        white-space: nowrap;
      }
    }
    .img {
      width: 100%;
      height: 30px;
      position: relative;
      opacity: 0.5;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .map-name-mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(#000000, 0.5);
        height: 12px;
      }
    }
    .state {
      height: 12px;
      width: 100%;
      background: #32b846;
      display: flex;
      justify-content: center;
      align-items: center;
      &.BAN {
        background: #fa3c4b;
        .state-text {
          span {
            width: 18px;
          }
        }
      }
      .team {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        background: #fff;
        img {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          object-fit: contain;
        }
      }
      .state-text {
        margin-left: 3px;
        height: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        span {
          font-family: 'Helvetica Neue';
          font-weight: 700;
          text-align: center;
          color: #ffffff;
          font-size: 12px;
          transform: scale(0.667) translateY(-0.5px);
          transform-origin: left;
          line-height: 15px;
          width: 20px;
        }
      }
    }
  }
}
</style>
